<template>
    <div id="dot">
      <div id="BMap"></div>
        <van-cell-group>
            <van-cell title="所在地区" :value="areaName" is-link @click="areaToggle"/>
            <van-cell title="物流公司" :value="companyCheck>-1?companyList[companyCheck].logisticsCompanyName:''" is-link @click="getCompanyList" />
        </van-cell-group>
        <div class="btn">
            <van-button type="primary" size="large" @click="searchDot">查询</van-button>
        </div>

        <div class="search-result" v-show="dotList.length > 0">
          <van-search v-model="searchKey" placeholder="请输入营业部、电话或地址">
          </van-search>
          <van-panel title="查询结果">

            <ul class="dot-list">
              <li class="dot-item" v-for="item in filterDot" :key="item.id">
                <div class="dot-info">
                  <span class="dot-photo"></span>
                  <div class="dot-detail">
                    <p class="dot-name">{{item.organName}}</p>
                    <p class="dot-address van-ellipsis">{{item.contactAddress}}</p>
                  </div>
                </div>
                <div class="dot-btn">
                  <van-icon @click="navigation(item.locationCoordinates,item.contactAddress)" style="border-right:1px solid #ddd" name="location">到这里去</van-icon><van-icon @click="call(item.customerPhone)" name="chat">联系电话</van-icon>
                </div>
              </li>
            </ul>

          </van-panel>
        </div>



        <!-- 省市区弹出框 -->
        <van-popup v-model="cityShow" position="bottom">
            <van-area :area-list="areaList" :value="areaId.toString()" @cancel="cancelArea" @confirm="confirmArea" />
        </van-popup>
        <!-- 物流公司选择框 -->
        <van-popup class="company-popup" position="bottom" v-model="companyShow">
        <h2 class="popup-title">
            <span>物流选择</span>
            <van-icon @click="companyToggle" name="close" size="0.5rem"></van-icon>
        </h2>
        <van-cell-group class="company-list">
            <van-cell v-if="companyList.length<=0">暂无物流公司！</van-cell>
            <van-cell @click="selCompany(index)" v-for="(item,index) in companyList" :key="item.logisticsCompanyId"
                    class="company-item">
            <span class="company-icon" slot="icon"></span>
            <van-row>
                <van-col span="24">{{item.logisticsCompanyName}}</van-col>
            </van-row>
            <van-row>
                <van-col span="24">
                价格：{{item.price}}/kg
                <span class="company-time">时效：{{item.time}}</span>
                </van-col>
            </van-row>
            </van-cell>
        </van-cell-group>
        </van-popup>
    </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import { city } from "../../utils/city.js";
export default {
  name: "Dot",
  data() {
    return {
      cityShow: false,
      companyShow: false,
      companyList: [],
      areaList: [],
      provinceId: "440000",
      cityId: "440100",
      areaId: "440106",
      areaName: "广东省-广州市-天河区",
      companyCheck: -1,
      dotList: [],
      searchKey: "",
      BMap: null
    };
  },
  computed: {
    filterDot() {
      let searchKey = this.searchKey;
      let arr = [];
      this.dotList.forEach(item => {
        if (
          item.contactAddress.indexOf(searchKey) !== -1 ||
          item.organName.indexOf(searchKey) !== -1 ||
          item.customerPhone.indexOf(searchKey) !== -1
        ) {
          arr.push(item);
        }
      });
      return arr;
    }
  },
  created() {
    this.areaList = city;
    this.getCurrentPosition(r => {
      let _province = r.address.province;
      let _city = r.address.city;
      let _district = r.address.district;
      let _districtId = "";
      let pId = "";
      for (let key in city.province_list) {
        if (city.province_list[key] === _province) {
          this.provinceId = key;
          pId = key.substr(0, 2);
        }
      }
      for (let key in city.city_list) {
        if (key.substr(0, 2) === pId && city.city_list[key] === _city) {
          this.cityId = key;
        }
      }
      for (let key in city.county_list) {
        if (key.substr(0, 2) === pId && city.county_list[key] === _district) {
          _districtId = key;
        }
      }
      this.areaId = _districtId;
      this.areaName = _province + "-" + _city + "-" + _district;
    });
  },
  methods: {
    areaToggle() {
      this.cityShow = !this.cityShow;
    },
    companyToggle() {
      this.companyShow = !this.companyShow;
    },
    // 取消地址选择器
    cancelArea() {
      this.areaToggle();
    },
    confirmArea(data) {
      this.areaId = data[2].code;
      this.areaName = data[0].name + "-" + data[1].name + "-" + data[2].name;
      this.provinceId = data[0].code;
      this.cityId = data[1].code;
      this.areaToggle();
    },
    getCompanyList() {
      let params = {
        params: {
          flag: "1",
          cityId: this.cityId,
          provinceId: this.provinceId
        }
      };
      this.$axios({
        url: "merchant/getLogisticsCompanyList",
        method: "post",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        data: params
      }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.companyList = data;
          this.companyToggle();
        }
      });
    },
    selCompany(index) {
      this.companyCheck = index;
      this.companyToggle();
    },
    searchDot() {
      if (this.areaId === "") {
        Dialog.alert({
          title: "温馨提示",
          message: "请选择地区！"
        }).then(() => {
          return;
        });
        return false;
      }
      if (this.companyCheck === -1) {
        Dialog.alert({
          title: "温馨提示",
          message: "请选择物流公司！"
        }).then(() => {
          return false;
        });
        return false;
      }
      let params = {
        params: {
          provinceId: this.provinceId,
          cityId: this.cityId,
          logisticsCompanyId: this.companyList[this.companyCheck]
            .logisticsCompanyId,
          logisticsCompanyName: this.companyList[this.companyCheck]
            .logisticsCompanyName,
          query: ""
        }
      };
      this.$axios({
        url: "merchant/get/Organ",
        method: "post",
        headers: {
          "content-type": "application/json;charset=utf-8"
        },
        data: params
      }).then(res => {
        if (res.data.code === 200) {
          let data = res.data.data;
          this.dotList = data;
          if (data.length === 0) {
            Toast({
              message: "无查询结果",
              duration: 2000
            });
          }
        }
      });
    },
    call(phone) {
      if (phone === "") {
        Dialog.alert({
          title: "温馨提示",
          message: "暂无联系电话"
        }).then(() => {
          return false;
        });
        return false;
      } else {
        Dialog.confirm({
          title: "拨打电话",
          message: phone
        })
          .then(() => {
            window.location.href = "tel:" + phone;
          })
          .catch(() => {
            return false;
          });
      }
    },
    /* ----------- */
    /* 百度地图 API */
    /* ----------- */
    // 获取当前位置
    getCurrentPosition(callback) {
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(
        function(r) {
          if (this.getStatus() == BMAP_STATUS_SUCCESS) {
            callback(r);
          } else {
            Toast({
              message: "获取位置信息失败，请刷新后重试",
              duration: 2000
            });
          }
        },
        { enableHighAccuracy: true }
      );
    },
    // 跳转至导航
    navigation(point, address) {
      Toast.loading({
        message: "定位中...",
        mask: true,
        duration: 0
      });
      let geolocation = new BMap.Geolocation();
      geolocation.getCurrentPosition(function(r) {
        if (this.getStatus() === BMAP_STATUS_SUCCESS) {
          Toast.clear();
          let location = {
            lat: r.point.lat,
            lng: r.point.lng,
            city: r.address.city
          };
          point = point.split(",");
          if (point[0] != "0.00" || point[1] != "0.00") {
            window.location.href =
              "https://api.map.baidu.com/direction?origin=latlng:" +
              location.lat +
              "," +
              location.lng +
              "|name:我家&destination=latlng:" +
              point[1] +
              "," +
              point[0] +
              "|name=" +
              address +
              "&mode=driving&region=" +
              location.city +
              "&output=html&src=广州云握科技有限公司";
          } else {
            myGeo.getPoint(address, function(point) {
              if (point) {
                window.location.href =
                  "https://api.map.baidu.com/direction?origin=latlng:" +
                  location.lat +
                  "," +
                  location.lng +
                  "|name:我家&destination=latlng:" +
                  point[1] +
                  "," +
                  point[0] +
                  "|name=" +
                  address +
                  "&mode=driving&region=" +
                  location.city +
                  "&output=html&src=广州云握科技有限公司";
              } else {
                Toast({
                  message: "位置信息解析失败",
                  duration: 2000
                });
              }
            });
          }
        } else {
          Toast.clear();
          Toast({
            message: "获取位置信息失败，请刷新后重试",
            duration: 2000
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#dot {
  .btn {
    margin: 0.25rem 0;
    padding: 0 0.25rem;
  }
  .dot-list {
    padding: 0 0.25rem 0.25rem;
    .dot-item {
      border: 1px solid #ddd;
      margin: 0.25rem 0;
      border-radius: 5px;
      .dot-info {
        padding: 0.25rem;
        display: flex;
        .dot-photo {
          width: 1.25rem;
          height: 1.25rem;
          display: inline-block;
          background-image: url(../../assets/wuliu1.png);
          background-size: 100%;
          background-repeat: no-repeat;
          border: 1px solid #ddd;
          margin-right: 0.25rem;
        }
        .dot-detail {
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          font-size: 0.375rem;
          .dot-name {
            color: #666;
          }
          .dot-address {
            max-width: 7rem;
          }
        }
      }
      .dot-btn {
        border-top: 1px solid #ddd;
        display: flex;
        .van-icon {
          color: #0b92e6;
          flex: 1;
          text-align: center;
          padding: 0.25rem 0 0.3rem;
          &::before {
            position: relative;
            top: 1px;
            left: -2px;
          }
        }
      }
    }
  }

  .popup-title {
    position: relative;
    display: flex;
    align-items: center;
    padding: 0.25rem;
    font-size: 0.4rem;
    .van-button {
      margin-left: 0.25rem;
    }
    .van-icon {
      position: absolute;
      right: 0.25rem;
    }
  }
  .company-popup {
    .company-list {
      max-height: 6rem;
      overflow-y: scroll;
      .company-item {
        .company-icon {
          width: 1.25rem;
          height: 1.25rem;
          display: block;
          background-image: url(../../assets/wuliu1.png);
          background-size: 100%;
          background-repeat: no-repeat;
          border: 1px solid #ddd;
          margin-right: 0.25rem;
        }
        .company-time {
          float: right;
        }
      }
    }
  }
}
</style>
